// extracted by mini-css-extract-plugin
export default {"main":"Uba-z"};